import { AnalyticsContext } from './AnalyticsContext';
var AnalyticsDispatcher = (function () {
    function AnalyticsDispatcher(dispatchAnalytics, context) {
        if (context === void 0) { context = new AnalyticsContext(); }
        this.dispatchAnalytics = dispatchAnalytics;
        this.context = context;
    }
    AnalyticsDispatcher.prototype.dispatch = function (eventName, analyticsContext) {
        if (eventName === void 0) { eventName = ''; }
        var unionContext = this.context.union(analyticsContext);
        return this.dispatchAnalytics(eventName, unionContext);
    };
    AnalyticsDispatcher.prototype.extend = function () {
        var extenders = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            extenders[_i] = arguments[_i];
        }
        return extenders.reduce(function (acc, extender) { return extender(acc); }, this);
    };
    return AnalyticsDispatcher;
}());
export { AnalyticsDispatcher };
//# sourceMappingURL=AnalyticsDispatcher.js.map